import React, {useEffect, useState} from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import http from "../../../services/api/utilities/http";
export default function SubMenu(props) {
    const [open, setOpen] = useState('');
    const [tableHeight, setTableHeight] = useState(0);
    const [viewHeight, setViewHeight] = useState(0);
    const [view,setView] = useState([])
    const [table,setTable] = useState([])
    const [tmp,setTmp] = useState({view:[],table:[]})
    useEffect(()=>{
            setTable(props.table.tables)
            setView(props.table.view)
            setTmp({view:props.table.view,table:props.table.tables})
    },[])
     const openTable = () => {
        if(open.includes('table'))
      {
          let _class = open
          _class = _class.replace('table','')
          _class = _class.replace('scroll-none-table','')
          setOpen(_class)
          setTableHeight(0)
      }
        else
            {
                if(table.length < 6){
                    setTableHeight(table.length * 44);setOpen(open+' table scroll-none-table')}
                else
                {setTableHeight(232);setOpen(open+' table')}
            }
    }
     const openView = () => {
        if(open.includes('view'))
        {
            let _class = open
            _class = _class.replace('view','')
            _class = _class.replace('scroll-none-view','')
            setOpen(_class)
            setViewHeight(0)
        }
        else
        {
            if(view.length < 6){
                setViewHeight(view.length * 44);setOpen(open+' view scroll-none-view')}
            else
            {setViewHeight(232);setOpen(open+' view')}
        }
    }
     const search = e => {
        setTable(tmp.table)
        setView(tmp.view)
        let { value } = e.target
        value=value.replace(/\s/g,'')
        let _tmpT = []
        let _tmpV = []
        if(value == '')
        {
            setTableHeight(0)
            setViewHeight(0)
            setOpen('')
            return true
        }
        let _open = 'view table';
        table.map(item=>{
            item.includes(value) && _tmpT.push(item)
        })
        view.map(item=>{
            item.includes(value) && _tmpV.push(item)
        })
        setTable(_tmpT)
        setView(_tmpV)
        console.log(_tmpT.length,_tmpV.length)
        if (_tmpT.length < 6) {
            setTableHeight(_tmpT.length * 44)
           _open += ' scroll-none-table'
        }else{
            setTableHeight(232)
        }
        if(_tmpV.length < 6) {
            setViewHeight(_tmpV.length * 44)
            _open += ' scroll-none-view'
        }else{
            setViewHeight(232)
        }
        setOpen(_open)
    }
     const sendData = table => {
        props.setTableDataPreview(table)
         http.post('data_connector/data_preview/',{
                 "data_source":props.table.id,
                 "table":table,
                 "event_log_template":5
             })
             .then(res => {
                 console.log('res',res.data)
                 props.setDataPreview(res.data.data)
                 props.goToPreview('Select Event Log');
             })
             .catch(err=>{
                 console.log(err.response)
             })
     }

    return (
           <div className={`sub-menu ${open}`} style={{height:tableHeight+viewHeight+166}}>
               <input onChange={search} placeholder="Search" className="search" type="text"/>
               <section onClick={openTable} className="d-flex justify-content-between align-items-center -table" >
                   <p>Tables</p>
                   <svg xmlns="http://www.w3.org/2000/svg" width="12.732" height="7.426" viewBox="0 0 12.732 7.426">
                       <g id="ArrowDown" transform="rotate(180 5.835 3.183)">
                           <path id="Line_19" d="M0 0L5.305 5.305" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1"
                                 transform="rotate(90 2.652 2.653)"/>
                           <path id="Line_20" d="M0 5.305L5.305 0" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1"
                                 transform="rotate(90 5.305 5.305)"/>
                       </g>
                   </svg>
               </section>
               <Scrollbars  className="scroll --table" style={{ width: 296, height: tableHeight }}>
                   {table.map((value,key) => (
                       <section onClick={() => props.selectTable(value)} key={key} className="d-flex">
                           <label key={key} className="checkmark-container">
                               <input  className="check-input"  type="checkbox"/>
                               <span className="checkmark"></span>
                           </label>
                           <p style={{marginTop:-3}}>{value}</p>
                       </section>
                       // <section onClick={() => sendData(value)} className="sub">
                       //    <p>{value}</p>
                       // </section>
                   ))}
               </Scrollbars>
               <section onClick={openView} className="d-flex justify-content-between align-items-center -view">
                   <p>Views</p>
                   <svg xmlns="http://www.w3.org/2000/svg" width="12.732" height="7.426" viewBox="0 0 12.732 7.426">
                       <g id="ArrowDown" transform="rotate(180 5.835 3.183)">
                           <path id="Line_19" d="M0 0L5.305 5.305" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1"
                                 transform="rotate(90 2.652 2.653)"/>
                           <path id="Line_20" d="M0 5.305L5.305 0" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1"
                                 transform="rotate(90 5.305 5.305)"/>
                       </g>
                   </svg>
               </section>
               <Scrollbars  className="scroll --view" style={{ width: 296, height: viewHeight }}>
                   {view.map((value,key) => (
                       <section onClick={() => props.selectTable(value)}  key={key} className="d-flex">
                           <label key={key} className="checkmark-container">
                               <input  className="check-input"  type="checkbox"/>
                               <span className="checkmark"></span>
                           </label>
                           <p style={{marginTop:-3}}>{value}</p>
                       </section>
                   ))}
               </Scrollbars>
           </div>
    );
}
